import { ConfirmModal } from '../../../shared/modal'

type ConfirmArchiveTemplateModalProps = {
  /** Determines visibility of modal */
  isOpen: boolean
  /** Label of template to delete */
  label: string
  /** Event callback when Confirm Button is triggered */
  onConfirm: () => void
}

const ConfirmArchiveTemplateModal = ({
  isOpen,
  label,
  onConfirm
}: ConfirmArchiveTemplateModalProps) => (
  <ConfirmModal
    confirmText={`Archive ${label}`}
    isOpen={isOpen}
    onConfirm={onConfirm}
    title={`Archive ${label}`}
  >
    Are you sure you want to archive this {label.toLowerCase()}?
    <p>
      You will not be able to share this {label.toLowerCase()} with students. Any student who
      already has this {label.toLowerCase()} on their plan will not be affected.
    </p>
  </ConfirmModal>
)

export default ConfirmArchiveTemplateModal
